import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PageWrapper } from "../UI/Grid";
import Table from "../UI/Table";
import { useTheme } from "styled-components";

const ImportsDashboard = () => {

  const navigate = useNavigate();
  const theme = useTheme();
  const { pid } = useParams();
 
  let gridData = useMemo(
    () => [
      {
        title: "Products",
        path: "/Imports/Products",
        iconName: "faBoxesStacked",
      },
      {
        title: "Customers",
        path: `/Imports/Customers`,
        iconName: "faIdCard",
      },
      {
        title: "Shipping Addresses",
        path: `/Imports/Address`,
        iconName: "faAddressBook",
      },
      {
        title: "Users",
        path: `/Imports/Users`,
        iconName: "faUsers",
      },
    ]
  );

  return (
    <>
      <PageWrapper>
        <Table
          title="Import Data"
          backButtonLink="/Administration"
          gridData={gridData}
          hideProperties
          hidePager
          hideCreate
          hideSearch
          hideToggle
          forceGrid
          onCardClick={(item) => navigate(item.path)}
        />
      </PageWrapper>
    </>
  );
}


export default ImportsDashboard;
